module.exports = __webpack_public_path__ + "img/location.1a9f2ee2.svg";